<template lang="pug">
aside-modal(id="grid-form", ref="modal", :loading="onLoading('create-order-layout')")
    template(slot="header-text") New Grid Layout
    template(slot="footer")
        button.btn.btn-fw.primary(type="button", @click="submit", :disabled="onLoading('create-order-layout')")
            v-loading(loader="create-order-layout") Create
    template(slot="body")
        .padding
            form(@submit.prevent="submit")
                fieldset(:disabled="onLoading('create-order-layout')")
                    .row
                        .col-md-12
                            .md-form-group
                                input.md-input(type="text", v-model="orderLayout.name", name="name", v-validate="'required'")
                                label Name
                                span.text-danger.block(v-show="errors.has('name')") {{ errors.first('name') }}

                        .col-md-12
                            .md-form-group
                                textarea.md-input(row="3", v-model="orderLayout.description", name="description")
                                label Description

                        .col-md-12
                            .md-form-group
                                label Outlet
                                select.md-input(v-model="orderLayout.outlet_id", v-validate="'required'", name="outlet")
                                    option(:value="null", disabled) Select Outlet
                                    option(:value="outlet.id", v-for="outlet in outletList", :key="outlet.id") {{ outlet.name }}
                                span.text-danger.block(v-show="errors.has('outlet')") {{ errors.first('outlet') }}

                        .col-md-12
                            p Grid Size

                        .col-md-6
                            .md-form-group
                                input.md-input(type="text", v-model="orderLayout.width", v-validate="'required|integer|min_value:2|max_value:7'", name="width")
                                label Width
                                span.text-danger.block(v-show="errors.has('width')") {{ errors.first('width') }}
            
                        .col-md-6
                            .md-form-group
                                input.md-input(type="text", v-model="orderLayout.height", v-validate="'required|integer|min_value:2|max_value:10'", name="height")
                                label Height
                                span.text-danger.block(v-show="errors.has('height')") {{ errors.first('height') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            orderLayout: {
                name: null,
                description: null,
                outlet_id: null,
                width: 4,
                height: 5,
            },
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),
    },

    mounted() {
        this.$on('show', () => this.$refs.modal.$emit('show'));
        this.$on('hide', () => this.$refs.modal.$emit('hide'));
    },

    created() {
        this.getOutletList();
    },

    methods: {
        ...mapActions('orderLayout', ['createOrderLayout']),
        ...mapActions('outlet', ['getOutletList']),

        async submit() {
            const validate = await this.$validator.validateAll();

            if (!validate) return;
            this.startLoading('create-order-layout');

            const { data } = await this.createOrderLayout(this.orderLayout);

            // redirect to order layout management page
            location.href = Laroute.route('franchise.order_layout.show', {
                id: data.id,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-create-form.vue